import { AxiosResponse } from 'axios';
import { apiClient } from '../instance';

export type ConsentKind = 'personal_data' | 'marketing';

export interface ConsentState {
  granted: boolean;
  version: string | null;
  at: string | null;
}

export interface ConsentsResponse {
  personal_data: ConsentState;
  marketing: ConsentState;
  current_version: string;
  /** Клиенту нужно подтвердить согласие на ПДн (окно при входе). */
  pd_required: boolean;
}

/** Журнал согласий (бэк: приложение legal, /v1/legal/consents/). */
export const legalApi = {
  getConsents: (): Promise<AxiosResponse<ConsentsResponse>> =>
    apiClient.get<ConsentsResponse>('legal/consents/'),

  setConsent: (data: {
    kind: ConsentKind;
    granted: boolean;
    version?: string;
    source?: string;
  }): Promise<AxiosResponse<ConsentsResponse>> =>
    apiClient.post<ConsentsResponse>('legal/consents/', data),
};
